import instance, { customConfig } from "../Utils/Interceptors/Interceptor";

const SimularCalculoCDOService = async (values) => {
	return await instance.Backend.post(
		"/Indicador/SimularCalculoCDO",
		values,
		{
			...customConfig,
			validateStatus: () => true,
		},
	);
};

export { SimularCalculoCDOService };
